// removed by extract-text-webpack-plugin
module.exports = {"container":"_2S4n","light":"cQem","wrapper":"_1ENb","text":"_3KpK"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/AboutUs/styles.scss
// module id = 460
// module chunks = 0